var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTotalFleet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tool-tip-promo",
    transform: "translate(-737.000000, -108.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-142",
    transform: "translate(737.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3541667,19.7916667 C20.4927083,19.7916667 19.7916667,19.090625 19.7916667,18.2291667 L19.7916667,14.5833333 C19.7916667,11.74375 18.159375,9.1875 15.60625,7.98645833 C15.4322917,6.42604167 14.10625,5.20833333 12.5,5.20833333 C10.8947917,5.20833333 9.56770833,6.42604167 9.39375,7.98541667 C6.840625,9.18645833 5.20833333,11.740625 5.20833333,14.5833333 L5.20833333,18.2291667 C5.20833333,19.090625 4.50729167,19.7916667 3.64583333,19.7916667 C3.35833333,19.7916667 3.125,20.025 3.125,20.3125 C3.125,20.6 3.35833333,20.8333333 3.64583333,20.8333333 L21.3541667,20.8333333 C21.6416667,20.8333333 21.875,20.6 21.875,20.3125 C21.875,20.025 21.6416667,19.7916667 21.3541667,19.7916667",
    id: "Fill-177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375,3.125 C5.928125,3.125 3.125,5.928125 3.125,9.375 C3.125,9.6625 3.35833333,9.89583333 3.64583333,9.89583333 C3.93333333,9.89583333 4.16666667,9.6625 4.16666667,9.375 C4.16666667,6.503125 6.503125,4.16666667 9.375,4.16666667 C9.6625,4.16666667 9.89583333,3.93333333 9.89583333,3.64583333 C9.89583333,3.35833333 9.6625,3.125 9.375,3.125",
    id: "Fill-179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375,1.04166667 C9.6625,1.04166667 9.89583333,0.808333333 9.89583333,0.520833333 C9.89583333,0.233333333 9.6625,0 9.375,0 C4.20520833,0 0,4.20520833 0,9.375 C0,9.6625 0.233333333,9.89583333 0.520833333,9.89583333 C0.808333333,9.89583333 1.04166667,9.6625 1.04166667,9.375 C1.04166667,4.78020833 4.78020833,1.04166667 9.375,1.04166667",
    id: "Fill-180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625,3.125 C15.3375,3.125 15.1041667,3.35833333 15.1041667,3.64583333 C15.1041667,3.93333333 15.3375,4.16666667 15.625,4.16666667 C18.496875,4.16666667 20.8333333,6.503125 20.8333333,9.375 C20.8333333,9.6625 21.0666667,9.89583333 21.3541667,9.89583333 C21.6416667,9.89583333 21.875,9.6625 21.875,9.375 C21.875,5.928125 19.0708333,3.125 15.625,3.125",
    id: "Fill-181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.625,0 C15.3375,0 15.1041667,0.233333333 15.1041667,0.520833333 C15.1041667,0.808333333 15.3375,1.04166667 15.625,1.04166667 C20.2197917,1.04166667 23.9583333,4.78020833 23.9583333,9.375 C23.9583333,9.6625 24.1916667,9.89583333 24.4791667,9.89583333 C24.7666667,9.89583333 25,9.6625 25,9.375 C25,4.20520833 20.79375,0 15.625,0",
    id: "Fill-182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5833333,21.875 L10.4166667,21.875 C10.1291667,21.875 9.89583333,22.1083333 9.89583333,22.3958333 C9.89583333,23.8322917 11.0645833,25 12.5,25 C13.9354167,25 15.1041667,23.8322917 15.1041667,22.3958333 C15.1041667,22.1083333 14.8708333,21.875 14.5833333,21.875",
    id: "Fill-178"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTotalFleet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/total_fleet.44fabcbc5182c4229d1a0a7df19e8998.svg";